import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchAreasRequest, deleteAreaRequest } from "../../../api/area";

class AreaTable extends Component {

  state = {
    data: null,
    error: null,
    loading: false
  };

  componentDidMount() {
    if (!this.state.data)
      this.fetchAreaData()
  }

  fetchAreaData(){
    this.setState({
      loading: true
    });
    fetchAreasRequest(
      result => this.setState({data: result, error: null, loading: false}),
      error => this.setState({error: error.message, loading: false})
    )
  };

  deleteArea = (id) => {
    deleteAreaRequest(
      id,
      result => this.fetchAreaData(),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );
  }

  render() {
    const { data } = this.state;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;


    return (
      <div className="content">
          <Row>
            <Col md={12}>
              <Card
                title="Area Table"
                category="List of Area entries to DB"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <CustomButtom className="table-top-btn btn-primary" onClick={() => this.props.goToCreateForm('area')}>
                      New Entry
                    </CustomButtom>
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Area Name</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ?
                          <td colSpan="2" style={{padding: "0"}}>
                            <div className="loader"></div>
                          </td>
                        :
                         (data && data.length > 0) 
                          ? data.map(instance => {
                            return (
                              <tr key={instance._id}>
                                <td>{instance.areaName || "N/A"}</td>
                                <td className="td-actions text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                                    <CustomButtom 
                                      bsStyle="success" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToDetails('area', instance._id)}
                                    >
                                      <i className="fa fa-eye" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={edit}>
                                    <CustomButtom 
                                      bsStyle="info" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToEditForm('area', instance._id)}
                                    >
                                      <i className="fa fa-edit" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <CustomButtom 
                                      bsStyle="danger" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.deleteArea(instance._id)}
                                    >
                                      <i className="fa fa-times" />
                                    </CustomButtom>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )}
                          )
                          : (
                            <tr>
                              <td colSpan='2'>There are no instances in the database yet.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  </div>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

export default AreaTable;
